module.exports = __webpack_public_path__ + "static/media/h1.02a91a6a.png";